import React from "react";
import { styled } from "@material-ui/core/styles";
import { format, parseISO } from 'date-fns';
import ru from 'date-fns/locale/ru'

const Cell = styled("div")({
  display: "flex",
  alignItems: "left"
});

const formatDate = (date) => format(
  parseISO(date),
  'dd.MM.yyyy HH:mm',
  {locale: ru}
);

const DateTimeCell = cellData => {
  const date = cellData.text;

  return <Cell>{date && formatDate(date)}</Cell>;
};

export default DateTimeCell;
